import { useState } from "react";
import { t } from "i18next";
import { Button } from "@/components/ui/Button";
import { useDeleteUserEvent, useMe } from "@/data/user";
import CaCheckMark from "@/components/icons/CaCheckMark";
import CaDeleteIcon from "@/components/icons/CaDeleteIcon";

const DeleteEvent = ({ eventId }: { eventId: number }) => {
  const { me } = useMe();

  const [eventDeleted, setEventDeleted] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  const { mutate, isLoading } = useDeleteUserEvent(
    me?.item.token as string,
    () => setEventDeleted(true),
  );

  const handleDelete = () => mutate(eventId);

  return (
    <>
      {!buttonClicked && !eventDeleted && (
        <Button
          variant="outline"
          onClick={() => setButtonClicked(true)}
          className="w-full !m-0 flex text-secondary justify-between border-secondary group font-semibold !text-base hover:bg-brand-red hover:border-brand-red"
        >
          {t("btns.delete_event")}
          <CaDeleteIcon className="text-brand-red group-hover:text-white" />
        </Button>
      )}

      {buttonClicked && !eventDeleted && (
        <div className="flex border-[1px] text-secondary font-semibold text-base justify-between rounded-md h-10 border-brand animate-in px-4 py-1 items-center">
          <p>Are you sure</p>

          <div className="flex flex-row gap-2 text-secondary">
            <Button
              onClick={handleDelete}
              isLoading={isLoading}
              className="text-xs py-1 h-fit  font-normal"
            >
              Yes
            </Button>

            <Button
              onClick={() => setButtonClicked(false)}
              className="text-xs py-1 h-fit bg-green-400 font-normal"
            >
              No
            </Button>
          </div>
        </div>
      )}

      {eventDeleted && (
        <div className="w-full !m-0 font-semibold text-base items-center px-3 h-10 border-[1px] rounded-lg text-secondary flex justify-between border-secondary group">
          {t("btns.delete_msg")}

          <CaCheckMark />
        </div>
      )}
    </>
  );
};

export default DeleteEvent;
